module.exports = __webpack_public_path__ + "48e8f76d97be2f1d0a5bf0dbe5544e3e.svg";